/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Reply_Portal_BlockedInputs */

const cs_messages_reply_portal_blocked = /** @type {(inputs: Messages_Reply_Portal_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpovězte e-mailem — portál nepřijímá odpovědi.`)
};

const en_messages_reply_portal_blocked = /** @type {(inputs: Messages_Reply_Portal_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply by e-mail — this portal does not accept replies.`)
};

/**
* | output |
* | --- |
* | "Reply by e-mail — this portal does not accept replies." |
*
* @param {Messages_Reply_Portal_BlockedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_reply_portal_blocked = /** @type {((inputs?: Messages_Reply_Portal_BlockedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Reply_Portal_BlockedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_reply_portal_blocked(inputs)
	return cs_messages_reply_portal_blocked(inputs)
});